<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
    <path fill="currentColor"
          d="M7.519 3.63 4.329.44a1.504 1.504 0 0 0-2.127 0L1.028 1.615A3.518 3.518 0 0 0 .005 4.3C.066 5.374.07 6.378.608 7.692c1.29 3.163 3.646 5.777 4.846 7.006 1.278 1.24 3.78 3.445 6.854 4.694 1.324.538 2.322.542 3.393.603a3.52 3.52 0 0 0 2.684-1.023l1.174-1.174a1.504 1.504 0 0 0 0-2.127l-3.189-3.19a1.504 1.504 0 0 0-2.127 0l-1.668 1.668a10.909 10.909 0 0 1-4.126-2.577A10.833 10.833 0 0 1 5.856 7.43l1.668-1.668a1.504 1.504 0 0 0 0-2.127l-.005-.005Z"/>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'Phone',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 20 20',
    },
  },
};
</script>

<style scoped>
  
</style>